import { render, staticRenderFns } from "./organization-configuration.vue?vue&type=template&id=52b4b0b2&scoped=true"
import script from "./organization-configuration.vue?vue&type=script&lang=js"
export * from "./organization-configuration.vue?vue&type=script&lang=js"
import style0 from "./organization-configuration.vue?vue&type=style&index=0&id=52b4b0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4b0b2",
  null
  
)

export default component.exports